





































































































import { Vue, Component } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import CompanyApi from '../store/api/CompanyApi';
import ICompany from '@/store/models/ICompany';
import BORTransactionsApi from '@/store/api/BORTransactionsApi';
import IBORTransactionDetails from '@/store/models/IBORTransactionDetails';

@Component({
    components: { Snackbar }
})
export default class Logs extends Vue {
  permissions: IRolePermission[] = [];
  idCompany: string = "";
  companyApi: CompanyApi;
  companyList: ICompany[] = [];
  overlay: boolean = false;
  borTransactionsApi: BORTransactionsApi;
  logs: IBORTransactionDetails[] = [];
  selectedTransactions: IBORTransactionDetails[] = [];
  searchTransactions: string = "";
  sortBy: string = 'dateOut';
  sortDesc: boolean = true;
  transactionHistory: string = "";
  transactionHistoryBlobUrl: string = "";
  headers = [
      { text: 'Inbound Code', value: 'inboundCode' },
      { text: 'Document Name', value: 'documentName' },
      { text: 'Customer', value: 'customer' },
      { text: 'Send Date', value: 'sendDate' },
      { text: 'Created Date', value: 'createdDate' },
      { text: 'Actions', value: 'actions', sortable: false }
  ];

  constructor() {
      super();
      this.borTransactionsApi = new BORTransactionsApi();
      this.companyApi = new CompanyApi();
  }

  created() {
      this.getPermissions();
      this.getTransactions();
  }

  async getTransactions() {
      this.logs = await this.borTransactionsApi.ReadAll();
  }

  getPermissions() {
      let userFromStorage: IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
      this.idCompany = userFromStorage.idCompany;
      this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Users"));
  }

  formatDate(date: Date): string {
      return date ? new Date(date).toLocaleDateString() : '';
  }

  async viewTransaction(item: IBORTransactionDetails) {
      this.transactionHistory = await this.borTransactionsApi.GetLogs(item.id);
      this.generateTransactionHistoryBlob();
  }

  generateTransactionHistoryBlob() {
      if (!this.transactionHistory) {
          this.transactionHistoryBlobUrl = "";
          return;
      }

      const blob = new Blob([this.transactionHistory], { type: "text/html" });

      if (this.transactionHistoryBlobUrl) {
          URL.revokeObjectURL(this.transactionHistoryBlobUrl);
      }

      this.transactionHistoryBlobUrl = URL.createObjectURL(blob);
  }

  selectTransactions(item : any) : void {
      if (!this.selectedTransactions.includes(item)) {
          this.selectedTransactions = [];
          this.selectedTransactions = [item];
      } else {
          this.selectedTransactions = [];
      }
  }
}
